export function addRegionNotes(zoneKey: string, structureGenerator: any, currentZoneX: number, currentZoneY: number): void {
    // Signs are being phased out - this function no longer places region notes
}
